import { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import ReactGA from '../ga';


const useDocTitle = (initialValue:string, retainOnUnmount:boolean = false) => {
  const defaultTitle = useRef(document.title);
  const history = useHistory();  
  const [doctitle, setDocTitle] = useState<string>(initialValue);
  
    useEffect(() => {
      if( doctitle.length > 0 ) {
        document.title = doctitle;
        ReactGA.pageview(history.location.pathname, [], doctitle);      
      }
    }, [doctitle]);
  
    useEffect(() => {
      return () => {
        if (!retainOnUnmount) {
          document.title = defaultTitle.current;
        }
      };
    }, []);
  
    return [doctitle, setDocTitle] as const;
  };
  
export default useDocTitle;